// extracted by mini-css-extract-plugin
export var arrows = "_80-6";
export var decrementer = "_80-a";
export var disabled = "_80-4";
export var error = "_80-1";
export var hiddenText = "_80-b";
export var incrementer = "_80-9";
export var input = "_80-8";
export var inputWrapper = "_80-0";
export var leadingIcon = "_80-c";
export var readonly = "_80-3";
export var regular = "_80-7";
export var small = "_80-5";
export var warning = "_80-2";